// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{margin:0}body>main{min-height:60vh}", "",{"version":3,"sources":["webpack://./src/ui/components/App/global.scss"],"names":[],"mappings":"AAAA,KACE,QAAA,CAEA,UACE,eAAA","sourcesContent":["body {\n  margin: 0;\n\n  > main {\n    min-height: 60vh;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
